import React, { createContext, useState, useContext } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const defaultAdmin = { name: "Nishant K.", role: "Super admin", email: "nishant@nopser.com" };
  
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return localStorage.getItem("logged_out") !== "true";
  });
  const [token, setToken] = useState(() => localStorage.getItem("token") || "nopser-admin-session-token");
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("userInfo");
    if (storedUser) {
      try {
        return JSON.parse(storedUser);
      } catch (e) {}
    }
    return defaultAdmin;
  });

  const login = (token, userDetails) => {
    localStorage.removeItem("logged_out");
    if (token) localStorage.setItem("token", token);
    if (userDetails) localStorage.setItem("userInfo", JSON.stringify(userDetails));
    setIsLoggedIn(true);
    setToken(token || "nopser-admin-session-token");
    setUser(userDetails || defaultAdmin);
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userInfo");
    localStorage.setItem("logged_out", "true");
    setToken(null);
    setUser(null);
    setIsLoggedIn(false);
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        token,
        user,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
